const RECONNECT_DELAYS = [1000, 2000, 5000, 10000];

export const subscribeToImpersonationChannel = (params, onMessage) => {
  const scheme = window.location.protocol === "https:" ? "wss" : "ws";
  const identifier = JSON.stringify({ channel: "ImpersonationChannel", ...params });
  let socket = null;
  let closed = false;
  let attempts = 0;
  let reconnectTimer = null;

  const connect = () => {
    socket = new WebSocket(`${scheme}://${window.location.host}/cable`);

    socket.onopen = () => {
      attempts = 0;
      socket.send(JSON.stringify({ command: "subscribe", identifier }));
    };

    socket.onmessage = (event) => {
      let data;
      try {
        data = JSON.parse(event.data);
      } catch (error) {
        return;
      }
      if (data?.type || data?.identifier !== identifier || !data?.message) return;
      onMessage(data.message);
    };

    socket.onclose = () => {
      if (closed) return;
      const delay = RECONNECT_DELAYS[Math.min(attempts, RECONNECT_DELAYS.length - 1)];
      attempts += 1;
      reconnectTimer = setTimeout(connect, delay);
    };
  };

  connect();

  return () => {
    closed = true;
    clearTimeout(reconnectTimer);
    if (socket) socket.close();
  };
};
